import * as React from 'react';
import { formatDate } from 'utils/dateUtils';
import './compPageTitle.scss';

export interface ICompPageTitleProps {
    employeeName: string;
    jobTitle: string;
    payEffectiveDate: string;
}

const CompPageTitle = (props: ICompPageTitleProps): React.ReactElement => {
    const { employeeName, jobTitle, payEffectiveDate } = props;

    return (
        <div className="comp-page-title">
            <h2 className="comp-page-title__employee-name">{employeeName}</h2>
            <p className="comp-page-title__job-title">{jobTitle}</p>
            <p className="comp-page-title__pay-effective">
                Effective Date <span className="comp-page-title__date">{formatDate(payEffectiveDate)}</span>
            </p>
        </div>
    );
};

export default CompPageTitle;
export { CompPageTitle };